module.exports = __webpack_public_path__ + "img/vantagens-premium.942f64b0.jpeg";